export default class ExtensionProjectsListCtrl {

	constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
		// constants
		const extensionVM = this
		const currentUser = JSON.parse($cookies.get('currentUser'))
		let post = {
			teacherId : currentUser.teacherId,
			workplanId: currentUser.workplanId,
		}

		extensionVM.viewLoaded = true
		extensionVM.criteriaFilter = ''
		extensionVM.projectParent = null
		extensionVM.details = details
		extensionVM.updateSearchView = updateSearchView
		extensionVM.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
		extensionVM.sr = ''
		extensionVM.searchValue = false
		extensionVM.feedback = 0
		extensionVM.planningFinish = true
		extensionVM.active = GlobalConfig.generals.active
		extensionVM.notActive = GlobalConfig.generals.notActive
		extensionVM.workPlanGeneralList = $sessionStorage.workPlanGeneralList
		extensionVM.sessionStorage = $sessionStorage
		$scope.classPlanning = ''

		// methods
		extensionVM.tagClas = tagClass
		extensionVM.projectBckgrd = projectBckgrd
		extensionVM.projectText = projectText
		extensionVM.getReviewData = getReviewData
		extensionVM.close = close
		extensionVM.addActivityExtensionProject = addActivityExtensionProject
		extensionVM.getGeneralsWorkplan = getGeneralsWorkplan
		extensionVM.updateFilter = updateFilter
		extensionVM.download = download
		extensionVM.downloadCross = downloadCross
		extensionVM.bitacora = bitacora
		extensionVM.disableProjectActivyId = disableProjectActivyId

		// data validations
		extensionVM.thereIsDetails = thereIsDetails

		// services

		angular.extend(extensionVM, {
			isLoadingDetails: false,
			filter          : '',
		})

		activate()

		function activate () {
			if (extensionVM.workPlanGeneralList != undefined) {
				extensionVM.status = extensionVM.workPlanGeneralList.wokplanTeacherStatus[0]
				extensionVM.stages = extensionVM.workPlanGeneralList.stages
				extensionVM.feedback = extensionVM.status.feedbackReviewed
				extensionVM.workplanTeacherId = extensionVM.status.workplanTeacherId
				isPlanning(extensionVM.status, extensionVM.stages)
        
				if (extensionVM.feedback && !extensionVM.planningFinish) {
					getReviewDataReject()
				} else { 
					getReviewData() 
				}
			} else {
				getGeneralsWorkplan(post).then((promise) => {
					if (extensionVM.feedback && !extensionVM.planningFinish) {
						getReviewDataReject()
					} else { 
						getReviewData() 
					}
				})
			}
		}

		function download () {
			let arrayChild = ''
			let titleChild = ''
			let date = new Date()

			date = moment(date).format('DDMMYYYY')

			if (extensionVM.projectChilds) {
				titleChild = 'Actividades en curso'
				for (var i = extensionVM.projectChilds.length - 1; i >= 0; i--) {
					arrayChild += extensionVM.projectChilds[i].name + ' - ' + extensionVM.projectChilds[i].hoursPlanned + 'hrs Planeadas \n'
				}
			}

			var docDefinition = {
				content: [
					{ text: extensionVM.projectParent.name, style: 'header' },
					{ text: 'Tipo de proyecto: ', style: 'title' },
					extensionVM.projectParent.listItemProjectTypeName,
					{ text: 'Rol en el proyecto:', style: 'title' },
					extensionVM.projectParent.listItemProjectRoleName,
					{ text: 'Unidad académica: ', style: 'title' },
					extensionVM.projectParent.academicUnitName,
					{ text: 'Financiadores: ', style: 'title' },
					extensionVM.projectParent.financialSourceName,
					{ text: 'Propuesta asociada: ', style: 'title' },
					extensionVM.projectParent.projectFormulatedName,
				],
				styles: {
					header: {
						fontSize: 16,
						bold    : true,
						margin  : [ 0, 10 ],
					},
					title: {
						bold: true,
					},
				},
			}

			if (extensionVM.projectParent.timeRangeTypeId == 1) {
				docDefinition.content.push({ text: 'Período', style: 'title' }, extensionVM.projectParent.periodicityName)
			} else {
				docDefinition.content.push({ text: 'Fecha inicio: ', style: 'title' }, moment(extensionVM.projectParent.startDate).format('DD/MM/YYYY'))
				docDefinition.content.push({ text: 'Fecha fin: ', style: 'title' }, moment(extensionVM.projectParent.endDate).format('DD/MM/YYYY'))
			}

			docDefinition.content.push({ text: 'Descripción: ', style: 'title' },
				extensionVM.projectParent.description,
				{ text: titleChild, style: 'header' },
				arrayChild)

			pdfMake.createPdf(docDefinition).download(extensionVM.projectParent.name + date + '.pdf')
		}

		function downloadCross () {
			let date = new Date()

			date = moment(date).format('DDMMYYYY')
			var docDefinition = {
				content: [
					{ text: extensionVM.projectParent.projectName, style: 'header' },
					{ text: 'Tipo de proyecto: ', style: 'title' },
					extensionVM.projectParent.itemProjectTypeName,
					{ text: 'Metodología:', style: 'title' },
					extensionVM.projectParent.methodology,
					{ text: 'Propósitos: ', style: 'title' },
					extensionVM.projectParent.purposes,
					{ text: 'Comunidades implicadas: ', style: 'title' },
					extensionVM.projectParent.communities,
					{ text: 'Objetivos: ', style: 'title' },
					extensionVM.projectParent.objectives,
					{ text: 'Resultados: ', style: 'title' },
					extensionVM.projectParent.results,
					{ text: 'Valor: ', style: 'title' },
					extensionVM.projectParent.value,
					{ text: 'Entidad: ', style: 'title' },
					extensionVM.projectParent.entityType,
				],
				styles: {
					header: {
						fontSize: 16,
						bold    : true,
						margin  : [ 0, 10 ],
					},
					title: {
						bold: true,
					},
				},
			}

			pdfMake.createPdf(docDefinition).download(extensionVM.projectParent.projectName + date + '.pdf')
		}

		function getReviewData () {
			WorkPlanSrv.getDataFormProjectsExtension.getList(post).$promise.then(
				dataReturn => {
					if (dataReturn.status) {
						extensionVM.projects = dataReturn.listProjectsExtension
						extensionVM.projectsCross = dataReturn.listProjectsCross
						for (var i = extensionVM.projectsCross.length - 1; i >= 0; i--) {
							extensionVM.projects.push(extensionVM.projectsCross[i])
						}

						if (extensionVM.projects.length == 0) {
							extensionVM.projectParent = true
						}

						if (extensionVM.projects.length == 0) {
							extensionVM.projectParent = 0
						}

						for (var i = extensionVM.projects.length - 1; i >= 0; i--) {
							if (extensionVM.projects[i].activityTypeId == GlobalConfig.typeProject.internal) {
								extensionVM.projects[i].activityTypeName = 'Proyecto Interno'
							} else {
								extensionVM.projects[i].activityTypeName = 'Proyecto Transversal'
							}
						}

						if (extensionVM.projects && extensionVM.projects.length > 0) {
							extensionVM.details(extensionVM.projects[0])
						}
					} else {
						console.log('Comunications problem')
					}
				},
				data => {
					console.log()
				},
			)
		}

		function getReviewDataReject () {
			WorkPlanSrv.getDataFormProjectsExtensionReject.getList(post).$promise.then(
				dataReturn => {
					if (dataReturn.status) {
						extensionVM.projects = dataReturn.listProjectsExtension

						if (extensionVM.projects.length == 0) {
							extensionVM.projectParent = true
						}

						if (extensionVM.projects.length == 0) {
							extensionVM.projectParent = 0
						}

						for (var i = extensionVM.projects.length - 1; i >= 0; i--) {
							if (extensionVM.projects[i].activityTypeId == GlobalConfig.typeProject.internal) {
								extensionVM.projects[i].activityTypeName = 'Proyecto Interno'
							} else {
								extensionVM.projects[i].activityTypeName = 'Proyecto Transversal'
							}
						}

						if (extensionVM.projects && extensionVM.projects.length > 0) {
							extensionVM.details(extensionVM.projects[0])
						}
					} else {
						console.log('Comunications problem')
					}
				},
				data => {

				},
			)
		}

		function getProjectsDetails (project, reload = false, callback) {
			if (!project.isProjectCross) {
				WorkPlanSrv.getProjectExtensionByActivityId.get({ workplanTeacherActivityId: project.workplanTeacherActivityId }).$promise.then(
					dataReturn => {
						if (dataReturn.status) {
							extensionVM.projectParent = dataReturn.data.parent
							extensionVM.projectChilds = dataReturn.data.childs

							if (!extensionVM.projectParent.projectFormulatedName)
								extensionVM.projectParent.projectFormulatedName = 'Sin propuesta asignada'

							if (extensionVM.projectParent.activityTypeId == GlobalConfig.typeProject.internalProject) {
								extensionVM.projectParent.activityTypeName = 'Proyecto Interno'
							} else {
								extensionVM.projectParent.activityTypeName = 'Proyecto Transversal'
							}
						} else {
							console.log('Comunications problem')
						}
					},
					data => {
						console.log()
					})
			} else {
				WorkPlanSrv.getProjectsCrossById.get({ transversalProjectsId: project.transversalProjectsId }).$promise.then(
					dataReturn => {
						if (dataReturn.status) {
							extensionVM.projectParent = dataReturn.data
						} else {
							console.log('Comunications problem')
						}
					},
					data => {
						console.log()
					},
				)
			}

			if (!reload) {
				extensionVM.isLoadingDetails = true
				extensionVM.projectParent = null
			}

			callback
		}

		function thereIsDetails () {
			return Boolean(extensionVM.projectParent)
		}

		function tagClass (project) {
			return 'azul'
		}

		function projectBckgrd (project) {
			if (extensionVM.selectedProject === project) {
				return 'bg-review'
			}
		}

		function projectText (project) {
			if (extensionVM.selectedProject === project) {
				return 'text-color-w'
			}
		}

		function details (project) {
			extensionVM.projectParent = null
			extensionVM.selectedProject = project
			extensionVM.isLoadingDetails = true
			getProjectsDetails(project, function () {
				extensionVM.isLoadingDetails = false
			})
		}

		function close () {
			return $mdDialog.hide()
		}

		function updateSearchView () {
			extensionVM.viewLoaded = true
			extensionVM.viewLoaded = false
			$timeout(() => {
				extensionVM.viewLoaded = true
			}, 100)
		}

		function addActivityExtensionProject (project, activity) {
			let header = {
				workplanTeacherActivityIdParent: project.workplanTeacherActivityId,
				children                       : activity || 'ADD',
				hoursChildren                  : project.hoursChildren,
			}

			WorkPlanModalSrv.setVariable(header)
			WorkPlanModalSrv.addActivityExtensionProject().then((promise) => {
				let shared = WorkPlanModalSrv.getVariable()

				if (shared.status) {
					if (shared.action == 'ADD') {
						extensionVM.projectChilds.push(shared.child)
					} else {
						for (var i = extensionVM.projectChilds.length - 1; i >= 0; i--) {
							if (extensionVM.projectChilds[i].workplanTeacherActivityId == shared.child.workplanTeacherActivityId) {
								extensionVM.projectChilds[i].name = shared.child.name
								extensionVM.projectChilds[i].hoursPlanned = shared.child.hoursPlanned
								extensionVM.projectChilds[i].description = shared.child.description
							}
						}
					}

					if (project.hoursChildren == 1) {
						extensionVM.projectParent.hoursPlanned = hoursPlanned()  

						for (var i = extensionVM.projects.length - 1; i >= 0; i--) {              
							if (extensionVM.projects[i].workplanTeacherActivityId == extensionVM.projectParent.workplanTeacherActivityId) {                
								extensionVM.projects[i].hoursPlanned = extensionVM.projectParent.hoursPlanned                
								break
							}
						}            
					}
				}
			})
		}

		function hoursPlanned() {
			var aux = 0

			for (var i = extensionVM.projectChilds.length - 1; i >= 0; i--) {          
				aux += extensionVM.projectChilds[i].hoursPlanned
			}
  
			return aux
		}

		function updateFilter (val) {
			extensionVM.sr = validateSearch()

			if (extensionVM.sr.length == 0) {
				extensionVM.searchValue = true
				extensionVM.projectParent = null
			} else {
				extensionVM.searchValue = false

				if (extensionVM.projects && extensionVM.projects.length > 0) { extensionVM.details(extensionVM.projects[0]) }
			}
		}

		function validateSearch () {
			return $filter('filter')(extensionVM.projects, extensionVM.criteriaFilter)
		}

		function getGeneralsWorkplan (post) {
			return WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					extensionVM.$sessionStorage.workPlanGeneralList = dataReturn.data
					extensionVM.status = dataReturn.data.wokplanTeacherStatus[0]
					extensionVM.stages = dataReturn.data.stages
					extensionVM.feedback = extensionVM.status.feedbackReviewed
					extensionVM.workplanTeacherId = extensionVM.status.workplanTeacherId
					isPlanning(extensionVM.status, extensionVM.stages)
				} else {
					console.log('Comunications problem with the server')
				}
			}, function (data) {
				console.log(data)
			})
		}

		function isPlanning (status, stages) {
			extensionVM.currentDate = moment(new Date()).format('DD/MM/YYYY')
			for (var i = stages.length - 1; i >= 0; i--) {
				if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
					extensionVM.startDateStage = stages[i].startDate
				}
			}

			if (status.workplanActive) {
				if (status.planningFinish == extensionVM.active) {
					extensionVM.planningFinish = true

					if (extensionVM.startDateReview < extensionVM.currentDate || status.reviewedFinish == extensionVM.active) {
						extensionVM.planningFinish = true
					} else if (status.reviewedReject == extensionVM.active) {
						extensionVM.planningFinish = false
					}
				} else {
					extensionVM.planningFinish = false
				}
			} else {
				extensionVM.planningFinish = true
			}

			$scope.classPlanning = (extensionVM.planningFinish ? 'disabled' : ' ')
		}

		function bitacora (ev) {
			let entries = {}

			entries.params = {
				activityTypeId   : GlobalConfig.activityTypeId.extensionProjects,
				workplanTeacherId: extensionVM.workplanTeacherId,
			}
			entries.title = 'Consultoría y asesoría'
			// Entries(this.entries);
			entries.data = undefined
			$mdDialog.show({
				controller         : 'bitacoraModalCtrl',
				controllerAs       : 'bit',
				template           : require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
				parent             : angular.element(document.body),
				targetEvent        : ev,
				locals             : { data: entries },
				clickOutsideToClose: true,
				fullscreen         : true,
			})
		}

		function disableProjectActivyId(project) {
			const header = {
				workplanTeacherActivityId: project.workplanTeacherActivityId,
			}
			const name = project.name

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					let ctrlModalVM = this

					ctrlModalVM.name = name
					ctrlModalVM.close = function () {
						$mdDialog.hide()
					}
					ctrlModalVM.delete = function () {
						WorkPlanSrv.disableActivity.delete(header)
							.$promise.then(function (dataReturn) {
								if (dataReturn.status) {
									showDeletedSuccessfully(ctrlModalVM.name)
									$mdDialog.hide()
								} else {
									console.log('Comunications problem with the server')
								}
							}, function (data) {
			
							})
					}
				} ],
				controllerAs       : 'ctrlModalVM',
				template           : require('./deleteModal.html'),
				clickOutsideToClose: false,
			})
		}

		function showDeletedSuccessfully(name) {
			let texts = GlobalConfig.appTexts
			let header = {
				createOrEdit    : texts.deleteDialog,
				textCreateOrEdit: texts.deleted,
				itemName        : name,
				nameModal       : texts.modalTypeName.deleted,
				modalType       : texts.modalTypeId.default,
			}
			
			WorkPlanModalSrv.setVariableSuccessDialog(header)
			WorkPlanModalSrv.successDialog(header).then((promise) => {
				if (extensionVM.workPlanGeneralList != undefined) {
					if (extensionVM.feedback && !extensionVM.planningFinish) {
						getReviewDataReject()
					} else { 
						getReviewData() 
					}
				} else {
					getGeneralsWorkplan(post).then((promise) => {
						if (extensionVM.feedback && !extensionVM.planningFinish) {
							getReviewDataReject()
						} else { 
							getReviewData() 
						}
					})
				}
			})  
		}
	}
	
}

ExtensionProjectsListCtrl.$inject = [ '$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/extensionProjects/list/extensionProjectsListCtrl.js